import { render } from "./Buildings.vue?vue&type=template&id=0a141886&scoped=true"
import script from "./Buildings.vue?vue&type=script&lang=js"
export * from "./Buildings.vue?vue&type=script&lang=js"

import "./Buildings.vue?vue&type=style&index=0&id=0a141886&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a141886"

export default script